/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchDamProductFolder = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_PRODUCT_FOLDER.FETCH_DAM_FOLDER_LIST}/${data?.devOrderId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProductDamFiles = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DAM_PRODUCT_FOLDER.UNLINK}/${payload?.devOrderId}/${payload?.folderId}`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
